import { render, staticRenderFns } from "./PurchasedProduct.vue?vue&type=template&id=a7af3324&"
import script from "./PurchasedProduct.vue?vue&type=script&lang=js&"
export * from "./PurchasedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports